export default "__VITE_ASSET__DMy4xOzA__"